import { render, staticRenderFns } from "./PremiumBadge.vue?vue&type=template&id=0026b3fe&scoped=true"
import script from "./PremiumBadge.vue?vue&type=script&lang=js"
export * from "./PremiumBadge.vue?vue&type=script&lang=js"
import style0 from "./PremiumBadge.vue?vue&type=style&index=0&id=0026b3fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0026b3fe",
  null
  
)

export default component.exports